import { createAction, props } from '@ngrx/store';
import { DeliveryTimeApiModel } from 'app/models/delivery-time-api.model';
import { DataRequest } from 'app/services/ag-grid/query-builder/models/query-builder-request.model';

export const loadDeliveryTimes = createAction(
  '[Delivery times] Load',
  props<{ loadOptions: DataRequest }>()
);

export const loadDeliveryTimesSuccess = createAction(
  '[Delivery times] Load Successful',
  props<{ response: DeliveryTimeApiModel[] }>()
);

export const loadDeliveryTimesFailed = createAction(
  '[Delivery times] Load Failure',
  props<{ error: any }>()
);

export const createDeliveryTime = createAction(
  '[Delivery times] Create',
  props<{ time: DeliveryTimeApiModel }>()
);

export const createDeliveryTimeSuccess = createAction(
  '[Delivery times] Create Successful'
);

export const createDeliveryTimeFailed = createAction(
  '[Delivery times] Create Failure',
  props<{ error: any }>()
);

export const updateDeliveryTime = createAction(
  '[Delivery times] Update',
  props<{ time: DeliveryTimeApiModel }>()
);

export const updateDeliveryTimeSuccess = createAction(
  '[Delivery times] Update Successful'
);

export const updateDeliveryTimeFailed = createAction(
  '[Delivery times] Update Failure',
  props<{ error: any }>()
);

export const deleteDeliveryTime = createAction(
  '[Delivery times] Delete',
  props<{ time: DeliveryTimeApiModel }>()
);

export const deleteDeliveryTimeSuccess = createAction(
  '[Delivery times] Delete Successful'
);

export const deleteDeliveryTimeFailed = createAction(
  '[Delivery times] Delete Failure',
  props<{ error: any }>()
);

export const deleteDeliveryTimesList = createAction(
  '[Delivery times] Delete list',
  props<{ times: DeliveryTimeApiModel[] }>()
);

export const deleteDeliveryTimesListSuccess = createAction(
  '[Delivery times] Delete list Successful'
);

export const deleteDeliveryTimesListFailed = createAction(
  '[Delivery times] Delete list Failure',
  props<{ error: any }>()
);
